// extracted by mini-css-extract-plugin
export var header = "Header-module--header--2XUBs";
export var headerCenter = "Header-module--headerCenter--2xQp0";
export var headerLogo = "Header-module--headerLogo--2T3Xl";
export var headerNavbar = "Header-module--headerNavbar--3Egy4";
export var headerNavbarItem = "Header-module--headerNavbarItem--2M6sr";
export var headerLongItem = "Header-module--headerLongItem--2XwIg";